import { lazy, Suspense, useEffect } from "react";
import { Box } from "@mui/material";
import { RouterContext } from "@propai-web/App";
import { TanStackDevtools } from "@tanstack/react-devtools";
import { ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools";
import { createRootRouteWithContext, Outlet, useLocation } from "@tanstack/react-router";
import posthog from "posthog-js";

const TanStackRouterDevtools = import.meta.env.PROD
  ? () => null // Render nothing in production
  : lazy(() =>
      // Lazy load in development
      import("@tanstack/router-devtools").then((res) => ({
        default: res.TanStackRouterDevtoolsPanel,
      }))
    );

const PostHogPageView = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (posthog) {
      posthog.capture("$pageview", {
        $current_url: pathname,
      });
    }
  }, [pathname]);
  return null;
};

const RootComponent = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        backgroundColor: "background.paper",
      }}
    >
      <Outlet />
      <Suspense>
        <TanStackDevtools
          plugins={[
            {
              name: "TanStack Query",
              render: <ReactQueryDevtoolsPanel />,
            },
            {
              name: "TanStack Router",
              render: <TanStackRouterDevtools />,
            },
          ]}
        />
      </Suspense>
      <PostHogPageView />
    </Box>
  );
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});
